import React, { useEffect, useState } from "react";
import externalLink from "../../assets/images/externalLink.png";
import { makeStyles } from "@material-ui/core/styles";
import calender from "../../assets/images/calender.png";
import update from "immutability-helper";
import JoinNowBtn from "./JoinNowbtn/JoinNowBtn";
import { Refresh } from "../RefreshButton/Refresh.jsx";
import {
  Typography,
  TableContainer,
  Table,
  TablePagination,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import CreateNewFolderIcon from "@material-ui/icons/CreateNewFolder";
import { API } from "../../Services/api-services";
import { useHistory } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import TagManager from "react-gtm-module";
import { EpicenterGTM } from "../../datalayers";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import StudentHistoryPopup from "../Glimpse/StudentHistoryPopup";
import UpcomingSessionCard from "./UpcomingSessionCard .jsx";
import ArrowForwardIcon from "@material-ui/icons/ArrowForwardIos";

var moment = require("moment");

const useStyles = makeStyles({
  shareContent: {
    boxSizing: "border-box",
    width: "100%",

    background: "#FFFDFA",
    border: "1px solid #FDECD9",
    boxShadow: "0px 1px 2px #FBE2C6",
    borderRadius: "8px",
  },
  spinnerDiv: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  headingDiv: {
    width: "100%",
    height: "48px",
    display: "flex",
    justifyContent: "space-between",
    paddingTop: "15px",
  },
  shareContentText: {
    height: "16px",
    padding: "0px 12px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "16px",
    color: "#7A7A7A",
  },
  calenderIcon: {
    margin: "-2px 0 0 0px",
    height: "15px",
    width: "15px",
    color: "#FF712D",
  },
  viewDetailsDiv: {
    paddingRight: "1.5%",
  },
  detailsLink: {
    textDecoration: "none",
    cursor: "pointer",
    height: "14px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "16px",
    color: "#FF712D",
    "&:hover": {
      color: "#FF712D",
    },
  },
  tableContainer: {
    boxSizing: "border-box",
    width: "100%",
    maxHeight: "432px",
    background: "#FFFDFA",
    border: "1px solid #FDECD9",
    boxShadow: "0px 1px 2px #FBE2C6",
    overflow: "auto",
  },
  tableHeader: {
    backgroundColor: "#F5F9FF",
    color: "#2761BA",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "16px",
    padding: "8px",
    width: "1236px",
    height: "48px",
  },
  tableCell: {
    width: "1232px",
    height: "64px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "16px",
    color: "#7A7A7A",
    background: "#FAFBFF",
  },
  refreshLink: {
    margin: "2.5% 0 0 2%",
    width: "23px",
    height: "23px",
    cursor: "pointer",
  },
  joinLinks: {
    display: "flex",
    width: "170px",
    justifyContent: "flex-end",
    AlignItem: "center",
    margin: "-3.5% 0 0 0",
  },
  externalLink: {
    cursor: "pointer",
  },
  cardComponentCls: {
    overflow: "auto",
    maxHeight: "410px",
  },
});

const UpcomingSessions = () => {
  const classes = useStyles();
  const history = useHistory();
  const [upcomingSessions, setupcomingSessions] = useState([]);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const mobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [historyPopup, setHistoryPopup] = useState(false);
  const [studentId, setStudentId] = useState();
  const [courseId, setCourseId] = useState();
  const [hitUpcomingSessionsAPI, setHitUpcomingSessionsAPI] = useState(false);

  const openHistoryPopup = (type, data) => {
    if (type === "open") {
      setHistoryPopup(true);
      setStudentId(data.studentDetails[0]?.studentId);
      setCourseId(data?.courseId);
    } else {
      setHistoryPopup(false);
    }
  };
  useEffect(() => {
    API.get("/getUpcomingSessions")
      .then((res) => {
        setupcomingSessions(res.data.upcomingSessions);
        setLoading(false);
      })

      .catch((e) => {
        setLoading(false);
        console.log("e: ", e);
      });
    setLoading(false);
  }, [hitUpcomingSessionsAPI]);

  const changeSessionUrl = (sessionUrl, index) => {
    const updatedBatchClasses = update(upcomingSessions, {
      [index]: { sessionUrl: { $set: sessionUrl } },
    });
    setupcomingSessions(updatedBatchClasses);
  };
  const dashboardGtmHandler = (data, action) => {
    const tagManagerArgs = EpicenterGTM(
      action,
      "class",
      "dashboard",
      data.courseName,
    );
    TagManager.dataLayer(tagManagerArgs);
    TagManager.initialize(tagManagerArgs);
    if (action === "va_opened") {
      window.open(`${data.visualAid}`, "_blank");
    } else {
      window.open(`${data.lessonData}`, "_blank");
    }
  };
  return (
    <div className={classes.shareContent}>
      {historyPopup && (
        <StudentHistoryPopup
          open={historyPopup}
          closeModal={openHistoryPopup}
          studentId={studentId}
          courseId={courseId}
        />
      )}
      <div
        className={classes.headingDiv}
        style={{
          alignItems: mobileScreen && "center",
          paddingTop: mobileScreen && "0px",
        }}
      >
        <Typography className={classes.shareContentText}>
          UPCOMING SESSIONS
        </Typography>
        {!mobileScreen && (
          <div className={classes.viewDetailsDiv}>
            <a
              className={classes.detailsLink}
              onClick={() => history.push(`/timetable`)}
            >
              <span style={{ fontSize: "14px" }}>View Time table </span>
            </a>
            {
              <ArrowForwardIcon
                className={classes.calenderIcon}
                onClick={() => history.push(`/timetable`)}
                fontSize="small"
              />
            }
          </div>
        )}
      </div>

      <TableContainer
        className={classes.tableContainer}
        style={{ overflow: "auto" }}
      >
        {loading ? (
          <div className={classes.spinnerDiv}>
            <Spinner animation="border" variant="secondary" className="my-3" />
          </div>
        ) : upcomingSessions.length > 0 ? (
          <div className={classes.cardComponentCls}>
            {upcomingSessions.map((session, index) => (
              <UpcomingSessionCard
                key={index}
                session={session}
                index={index}
                setHitUpcomingSessionsAPI={setHitUpcomingSessionsAPI}
              />
            ))}
          </div>
        ) : (
          <div className="text-center h3 my-3">No entries found!</div>
        )}
      </TableContainer>
    </div>
  );
};

export default UpcomingSessions;
